import parser from 'ua-parser-js'
import ClassificationOfArticle from 'components/pages/Article/ClassificationOfArticle'
import ArticleContent from 'components/pages/Article/ArticleContent'
import ClassificationOfArticleMetaTags from 'components/pages/Article/ClassificationOfArticle/MetaTags'
import ArticleMetaTags from 'components/pages/Article/ArticleContent/MetaTags'

import withLivingSinyi from 'utils/withLivingSinyi'
import withSafeServerSideProps from 'utils/server-utils/with-safe-server-side-props'
import NoindexRemoval from 'components/common/NoindexRemoval'
import {
  getArticleByUrlId,
  getArticleClassifications,
  getArticles,
} from 'utils/api'

const ClassificationOfArticlePage = (props) => {
  const { articleClassifications, articles, tabIndex } = props.fallbackData
  return (
    <>
      <NoindexRemoval />
      {articles.length > 0 ? (
        <ClassificationOfArticleMetaTags
          resolvedUrl={props.resolvedUrl}
          articleClassification={articleClassifications[tabIndex]}
          article={articles?.[0]}
        />
      ) : (
        <ArticleMetaTags
          resolvedUrl={props.resolvedUrl}
          article={props.fallbackData?.article}
        />
      )}
      {articles.length > 0 ? (
        <ClassificationOfArticle {...props} />
      ) : (
        <ArticleContent {...props} />
      )}
    </>
  )
}

export const getServerSideProps = withSafeServerSideProps(async (context) => {
  const { res } = context
  const ua = parser(context.req.headers['user-agent'])
  const isMobile = ['mobile', 'tablet'].includes(ua.device.type)

  const urlIdSource = context.params.classificationUrlId

  // detect if it's an article urlId
  let articleUrlId = urlIdSource.replace(/^DOC_/, 'doc_')
  let [article, errorByUrlId] = await getArticleByUrlId(articleUrlId)

  // 若無法取得文章，檢查是否為下架或過期
  if (!article) {
    let [_article, _errorByUrlId] = await getArticleByUrlId(urlIdSource, {
      isForPreview: true,
    })
    if (_article) {
      res.setHeader('Cache-Control', 'max-age=300')
      return {
        redirect: {
          destination: `/article-classification/${_article.articleClassification.urlId}`,
          permanent: true, // true = 308, false = 307
        },
      }
    }
  }

  const [articleClassifications, error] = await getArticleClassifications()
  const index = (articleClassifications || []).findIndex(
    (item) => item.urlId === urlIdSource
  )
  const [articles, articlesError] =
    index > -1
      ? await getArticles({
          articleClassificationIds: [articleClassifications[index]._id],
          limit: 20,
        })
      : [[]]

  if (index > -1) {
    res.setHeader('Cache-Control', 'max-age=300')
    return {
      redirect: {
        destination: `/article-classification/${urlIdSource}`,
        permanent: true,
      },
    }
  }

  if (articles.length === 0 && (errorByUrlId || !article)) {
    // API 失敗 ≠ 內容不存在：停機時不可誤報 404（會害活頁面被搜尋引擎除名），
    // 丟給 withSafeServerSideProps 分流（審核器 302 首頁、一般人 500）
    if (errorByUrlId) {
      throw errorByUrlId
    }
    if (error) {
      throw error
    }
    return { notFound: true }
  }

  return {
    props: {
      isMobile,
      fallbackData: {
        articleClassifications: articleClassifications || [],
        articles: articles,
        tabIndex: index,
        article: article ? article : null,
      },
      resolvedUrl: context.resolvedUrl,
    },
  }
})

export default withLivingSinyi(ClassificationOfArticlePage)
